import * as React from "react";
import {Bootstrap} from "../PageBuilder/Bootstrap";
import ReactDOM = require("react-dom");
import {TemplateListApp} from "./TemplateListApp";
import {WpAjaxPost} from "shared/utilities/ajax/WPAjaxPost";


export class TemplateListBootstrap extends React.Component<TemplateListBootstrapProps, TemplateListBootstrapState> {
    static defaultProps: Partial<TemplateListBootstrapProps> = {};

    constructor(props: TemplateListBootstrapProps) {
        super(props);
        this.state = {};
        WpAjaxPost.SetGlobalVar(rednaoVarTemplateList);
    }

    public render() {
        return (
            <TemplateListApp/>
        )
    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface TemplateListBootstrapProps {

}

interface TemplateListBootstrapState {

}


ReactDOM.render(<TemplateListBootstrap/>,document.getElementById('AppRoot'));

//#endregion "My Region"